import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ItineraryService } from '../../search-result/services/itinerary.service';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { APIService } from 'src/app/core/api/general.service';
import { map, catchError, take } from 'rxjs/operators';
import { SpecialRequestService } from 'src/app/special-requests/services/special-request.service';
import { QuoteRequest } from 'src/app/core/models/itinerary.model';
import { OptionType } from 'src/app/core/enums/enums';

@Injectable()
export class SpecialRequestGuard implements CanActivate {
  constructor(
    private api: APIService,
    private itineraryService: ItineraryService,
    private specialRequestService: SpecialRequestService,
    private layoutService: LayoutService
  ) {}

  loadSpecialRequest(quoteRequest: QuoteRequest) {
    return this.api.getSpecialRequestCategoryQuote(quoteRequest).pipe(
      map(response => {
        this.itineraryService.getPnrBaseInfo();
        this.layoutService.dispatchChangeBreadcrumb(
          this.itineraryService.pnr,
          OptionType.SpecialRequest
        );
        this.specialRequestService.dispatchGetSpecialRequestQuoteSuccess(
          response
        );
        return !!response;
      }),
      catchError(response => {
        this.itineraryService.dispatchGenericError(response.error);
        return this.error();
      })
    );
  }

  error() {
    this.itineraryService.navigateToWithParams('/itinerary');
    return of(false);
  }

  canActivate(): Observable<boolean> {
    let quoteRequest: QuoteRequest;
    this.itineraryService
      .getQuoteRequest()
      .pipe(take(1))
      .subscribe(response => {
        return !!response ? (quoteRequest = response) : this.error();
      });
    return this.loadSpecialRequest(quoteRequest);
  }
}
